import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import {
  FormGroup,
  FormBuilder,
  Validators,
  FormArray,
  FormControl,
  ValidationErrors,
} from "@angular/forms";
import { TranslateService } from "@ngx-translate/core";
import { NotificationsService } from "../../../../../../theme/services/notifications/notifications.service";
import { calendarES } from "../../../../../../theme/functions/calendarES";
import { CandidateDisabilitiesService } from "../../../../services/candidate-disabilities.service";
import {
  ListInsurances,
  TypesOfDisabilitiesAdmin,
  TypesOfContingencies,
  IsTranscribedOptions,
  documentsTypeDisabilities,
} from "../../../candidate-disabilities/data.constants";
import { formatDate } from "../../../../../../theme/functions/formatDate.function";
import { ActivatedRoute, Router } from "@angular/router";
import { getDiffDateDisabilty } from "../../../../../../theme/functions/getDiffDate.function";
import { sortObj } from "../../../../../../theme/functions/sortObj.function";
import { HasPermissionService } from "../../../../../employee/service/has-permission/has-permission.service";
import { config } from "../../../../../../../environments/config";

@Component({
  selector: "app-new-candidate-disabilities-admin",
  templateUrl: "./new-candidate-disabilities-admin.component.html",
  styleUrls: ["./new-candidate-disabilities-admin.component.scss"],
})
export class NewCandidateDisabilitiesAdminComponent implements OnInit {
  @Output() msg: EventEmitter<object> = new EventEmitter<object>();
  @Output() close: EventEmitter<boolean> = new EventEmitter<boolean>();

  public form: FormGroup;
  public typesOfDisabilities = [...TypesOfDisabilitiesAdmin];
  public listInsurances = [];
  public listInsurancesOptions = [...ListInsurances];
  public ListTypesOfContingencies = TypesOfContingencies;
  public isTranscribedOptions = [...IsTranscribedOptions];
  public selectedDisability: string | null = null;
  public es: any;
  public edit: any;
  private id: number;
  public show: number = 0;
  public loading: boolean = false;
  public promiseForm: Promise<any>;
  public apiUrl = config.API_ROOT;
  public alertMessage: string = "";
  public formGroupNameDocuments = "documents";
  public diffDays: number;
  public dailySalary: number;

  constructor(
    public fb: FormBuilder,
    public translate: TranslateService,
    private disabilityService: CandidateDisabilitiesService,
    public hasPermissionService: HasPermissionService,
    private notificationsService: NotificationsService,
    private route: ActivatedRoute,
    private router: Router,
  ) {
    this.es = calendarES();
    this.isTranscribedOptions = this.translateLabels(
      this.isTranscribedOptions,
      "label",
    );
  }

  public translateLabels(array: any[], labelKey: string) {
    return array.map((item) => {
      this.translate.get(item[labelKey]).subscribe((translatedLabel: string) => {
        item[labelKey] = translatedLabel;
      });
      return item;
    });
  }

  ngOnInit(): void {
    // this.loadCandidateInfo();
    this.id = +this.route.snapshot.paramMap.get("id");

    if (this.id !== 0 && this.id !== undefined) {
      this.disabilityService
        .infoDisability(this.id)
        .toPromise()
        .then(
          (response) => {
            this.edit = response.json();
            this.createNewRequestForm(this.edit);
            this.show = 1;
          },
          (error) => {
            this.notificationsService.growlNotify(
              "error",
              "ID " + this.id + " no encontrado",
            );
            this.router.navigateByUrl("/pages/disabilities");
          },
        );
    } else {
      this.createNewRequestForm();
      this.show = 1;
    }
  }
  createNewRequestForm(data: any = null) {
    data = data || {
      id: undefined,
      candidate_id: "",
      list_disabilities_type_id: "",
      type_of_contingency_id: "",
      diagnostic_id: null,
      start_date: "",
      end_date: "",
      type_insurance_id: "",
      insurance_id: "",
      previous_id: null,
      additional_info: "",
      // status_id: '',
      observation: "",
      is_transcribed: "",
    };

    let start_date_permission = this.hasPermission(
      "edit start date disability",
    );
    let end_date_permission = this.hasPermission("edit end date disability");
    let type_of_contingency_id_permission = this.hasPermission(
      "edit contingency type disability",
    );
    let type_insurance_id_permission = this.hasPermission(
      "edit insurance type disability",
    );
    let insurance_id_permission = this.hasPermission(
      "edit insurance disability",
    );
    let observation_permission = this.hasPermission(
      "edit observation disability",
    );

    this.form = this.fb.group({
      candidate_id: [
        { value: data.candidate_id, disabled: this.edit },
        this.edit ? [] : Validators.required,
      ],
      list_disabilities_type_id: [
        data.list_disabilities_type_id,
        this.edit ? [] : Validators.required,
      ],
      start_date: [
        {
          value: data.start_date ? new Date(data.start_date) : null,
          disabled: !start_date_permission,
        },
        start_date_permission ? [] : Validators.required,
      ],
      end_date: [
        {
          value: data.end_date ? new Date(data.end_date) : null,
          disabled: !end_date_permission,
        },
        end_date_permission ? [] : Validators.required,
      ],
      additional_info: [
        { value: data.additional_info, disabled: this.edit },
        Validators.maxLength(500),
      ],
      diagnostic_id: [data.diagnostic_id, []], //this.edit ? Validators.required :
      previous_id: [data.previous_id, []],
      type_insurance_id: [
        {
          value: data.type_insurance_id,
          disabled: !type_insurance_id_permission,
        },
      ],
      insurance_id: [
        { value: data.insurance_id, disabled: !insurance_id_permission },
        !insurance_id_permission ? [] : Validators.required,
      ],
      type_of_contingency_id: [
        {
          value: data.type_of_contingency_id,
          disabled: !type_of_contingency_id_permission,
        },
        !type_of_contingency_id_permission ? [] : Validators.required,
      ],
      observation: [
        { value: data.observation, disabled: !observation_permission },
        Validators.maxLength(500),
      ],
      is_transcribed: [
        data.is_transcribed === null || data.is_transcribed === undefined
          ? ""
          : String(data.is_transcribed),
        Validators.required,
      ],
      status_tracking: this.fb.array([]),
      idsToRemove: [],
    });
    this.updateOptions();
  }

  public cancel() {
    this.form.reset();
    this.close.emit(true);
    this.router.navigateByUrl("/pages/disabilities");
  }

  public saveAndExit() {
    if (this.form.valid) {
      this.createFormDataAndSave();
      this.close.emit(true);
    } else {
      // this.getFormValidationErrors(this.form);
    }
  }

  // Función auxiliar para formatear valores
  public formatValue = (value: any) => {
    if (value == null) return value;
    if (value instanceof Date) return formatDate(value);
    if (value.id) return value.id;
    if (value.code) return value.code;
    return value;
  };

  private createFormDataAndSave() {
    const formData = new FormData();
    const values = this.form.getRawValue();
    const list_disabilities_type_id = values.list_disabilities_type_id
      ? values.list_disabilities_type_id
      : this.edit.list_disabilities_type_id;
    const list_disabilities_type = this.typesOfDisabilities.find(
      (el) => el.value == list_disabilities_type_id,
    );
    const control_process_additional = [
      this.formGroupNameDocuments,
      "status_tracking",
      "idsToRemove",
    ];

    // Agregar los valores del formulario principal, excluyendo los adicionales
    Object.entries(values).forEach(([key, value]) => {
      if (!control_process_additional.includes(key)) {
        formData.append(key, this.formatValue(value));
      }
    });

    // Agregar los elementos de status_tracking
    values.status_tracking.forEach((item, index) => {
      Object.entries(item).forEach(([key, value]) => {
        if (value != null && value != "") {
          if (key == "received_amount" || key == "ibc")
            value = value.toString().replace(/[\.,]/g, "");
          formData.append(
            `disabilities_status[${index}][${key}]`,
            this.formatValue(value),
          );
        }
      });
    });

    // Agregar documentos al FormData
    const documentsGroup = this.form.get(
      this.formGroupNameDocuments,
    ) as FormGroup;
    if (documentsGroup) {
      Object.entries(documentsGroup.controls).forEach(([key, control]) => {
        const formArray = control as FormArray;
        if (formArray && formArray.controls.length > 0) {
          formArray.controls.forEach((fileControl: FormControl) => {
            const fileValue = fileControl.value;
            // Verificamos si tiene un ID
            const documentId = fileValue.id;
            // Si no tiene un ID, es un documento nuevo, lo agregamos al FormData
            if (!documentId) {
              formData.append(`documents[${key}][]`, fileValue);
            }
          });
        }
      });
    }

    // Agregar los IDs de documentos a eliminar al FormData
    var idsToRemove = this.form.get("idsToRemove").value || [];
    this.deleteDocumentForChangeDisabilityType(
      idsToRemove,
      list_disabilities_type_id,
    );
    if (idsToRemove.length > 0) {
      formData.append("removed_documents", JSON.stringify(idsToRemove));
    }

    this.loading = true;
    const savePromise = this.edit
      ? this.disabilityService.updateDisabilityAdmin(this.edit.id, formData)
      : this.disabilityService.newDisabilityAdmin(formData);

    this.promiseForm = savePromise.toPromise().then(
      (response) => {
        this.translate.get("Guardado exitoso").subscribe((res: string) => {
          this.notificationsService.growlNotify("success", res);
        });
        this.msg.emit(response);
        this.form.reset();
        this.router.navigateByUrl("/pages/disabilities");
      },
      (error) => {
        let msg = "saving"; //'guardando operación';
        let msg_error = error._body;
        this.translate.get("error").subscribe((res: string) => {
          this.translate.get(msg).subscribe((res1: string) => {
            this.notificationsService.growlNotify(
              "error",
              res + " " + res1 + msg_error,
            );
          });
        });
      },
    );
  }

  public onChangeTypeOfContingency() {
    this.form.get("previous_id").setValue(null);
  }

  // Método llamado cuando el tipo de discapacidad cambia
  public onDisabilityChange() {
    this.updateOptions();
    this.setSomeValues();
  }

  public setSomeValues() {
    var array_doesnt_prorroga = ["maternal_leave", "parental_leave"];
    var type_insurance_id = "1";
    if (this.selectedDisability == "work_accident") {
      type_insurance_id = "2";
      this.form.get("insurance_id").setValue(this.listInsurances[0].value);
    } else if (array_doesnt_prorroga.includes(this.selectedDisability)) {
      this.form
        .get("type_of_contingency_id")
        .setValue(this.ListTypesOfContingencies[0].value);
    } else {
      this.form.get("insurance_id").setValue("");
      this.form.get("type_of_contingency_id").setValue("");
    }
    this.form.get("type_insurance_id").setValue(type_insurance_id);
    this.form.get("previous_id").setValue(null);
  }

  public updateOptions() {
    let list_disabilities_type_id = this.form.get(
      "list_disabilities_type_id",
    ).value;
    let disabililty = this.typesOfDisabilities.find(
      (element) => element.value == list_disabilities_type_id,
    );
    this.selectedDisability = disabililty ? disabililty.value_form : null;
    this.updateOptionsInsurances();
    this.updateOptionsTypeContingencies();
  }

  public getDiffDateLoc(date_start: string, date_end: string): number {
    this.diffDays = getDiffDateDisabilty(date_start, date_end);

    // Calcular el salario diario
    if (this.edit && this.edit.contract && this.edit.contract.salary) {
      const monthlySalary = parseFloat(this.edit.contract.salary); // Convertir a número
      this.dailySalary = (monthlySalary / 30) * this.diffDays; // Dividir entre 30
    } else {
      this.dailySalary = 0; // Si no hay salario, establecer en 0
    }

    // Establecer el mensaje de alerta y manipular los validadores
    if (this.diffDays <= 2) {
      this.alertMessage = `Resumen De La Atención / Epicrisis ya no es obligatoria ya que la incapacidad tiene una duración de ${
        this.diffDays
      } ${this.diffDays === 1 ? "Día" : "Días"}.`;
      this.updateEpicrisisValidators(false); // Quitar validadores
    } else {
      this.alertMessage = ""; // Limpiar el mensaje
      this.updateEpicrisisValidators(true); // Agregar validadores
    }

    return this.diffDays;
  }

  // Función para agregar o quitar el validador 'required' del 'epicrisis'
  private updateEpicrisisValidators(isRequired: boolean) {
    const formGroupDocuments = this.form.get(
      this.formGroupNameDocuments,
    ) as FormGroup;
    if (formGroupDocuments) {
      const epicrisisArray = formGroupDocuments.get("epicrisis") as FormArray;
      if (epicrisisArray) {
        if (isRequired) {
          epicrisisArray.setValidators([Validators.required]); // Agregar el validador 'required'
        } else {
          epicrisisArray.clearValidators(); // Quitar el validador 'required'
        }
        epicrisisArray.updateValueAndValidity(); // Actualizar la validez
      }
    }
  }

  public MergeDocuments(idDisability: number) {
    window.open(
      this.apiUrl +
        "/disabilities-merge-documents/" +
        idDisability +
        "?token=" +
        localStorage.getItem("token"),
      "_blank",
    );
  }

  public updateOptionsInsurances() {
    if (this.selectedDisability == "work_accident") {
      this.listInsurances = this.listInsurancesOptions.filter((insurance) => {
        return insurance.type_insurance_id != "1";
      });
      // this.form.get('insurance_id').setValue(this.listInsurances[0].value);
    } else {
      this.listInsurances = this.listInsurancesOptions.filter((insurance) => {
        return insurance.type_insurance_id == "1";
      });
      this.listInsurances = sortObj(this.listInsurances, "asc");
      // this.form.get('insurance_id').setValue("");
    }
  }

  public updateOptionsTypeContingencies() {
    var array_doesnt_prorroga = ["maternal_leave", "parental_leave"];
    if (array_doesnt_prorroga.includes(this.selectedDisability)) {
      this.ListTypesOfContingencies = TypesOfContingencies.filter(
        (contingency) => {
          return contingency.label == "Initial";
        },
      );
      // this.form.get('insurance_id').setValue(this.listInsurances[0].value);
    } else {
      this.ListTypesOfContingencies = TypesOfContingencies;
      // this.form.get('insurance_id').setValue("");
    }
  }
  public hasPermission(permission) {
    return this.hasPermissionService.hasPermission(permission);
  }

  public getFormValidationErrors(form: FormGroup): string[] {
    let errors: string[] = [];
    const array_forms = Object.keys(form.controls);

    // Obtener los errores de los controles
    errors = this.getErrorString(array_forms, form);

    // Devolver el primer error que encuentre
    return errors.length ? [errors[0]] : [];
  }

  public getErrorString(array_forms: any, form_local: any): string[] {
    let errors: string[] = [];

    for (let i = 0; i < array_forms.length; i++) {
      const key = array_forms[i];
      const control = form_local.get(key);

      // Si el control es un FormGroup, iteramos sobre sus controles internos
      if (control instanceof FormGroup) {
        // Llamada recursiva a los controles internos del FormGroup
        errors = errors.concat(
          this.getErrorString(Object.keys(control.controls), control),
        );
      }
      // Si el control tiene errores, lo procesamos
      else if (control.errors) {
        const controlErrors: ValidationErrors = control.errors;
        const keyError = Object.keys(controlErrors)[0];
        let key_with_spaces = this.deleteUnderLine(key);
        let key_translated = "";
        let error_translated = "";

        // Traducción del nombre del campo
        this.translate.get(key_with_spaces).subscribe((res: string) => {
          key_translated = res;
        });

        // Traducción del error
        this.translate.get(keyError).subscribe((res: string) => {
          error_translated = res;
        });

        // Almacenamos el primer error en el arreglo de errores
        if (key_translated && error_translated) {
          errors.push(`Campo: ${key_translated}, Error: ${error_translated}`);
        }
      }
    }

    return errors;
  }

  public deleteUnderLine(chain: string): string {
    return chain.replace(/_/g, " ");
  }

  public deleteDocumentForChangeDisabilityType(
    idsToRemove: number[],
    selectedOption: number,
  ) {
    if (this.edit && this.edit.documents) {
      // Obtener la lista de documentos permitidos para la opción seleccionada
      const selectedOptionConfig = documentsTypeDisabilities.find(
        (docType) => docType.id == selectedOption,
      );

      if (selectedOptionConfig) {
        // Iterar sobre los documentos actuales
        this.edit.documents.forEach((document) => {
          const documentTypeId = document.list_documents_type_disabilities_id; // ID del tipo de documento

          // Verificar si el tipo de documento NO está en la lista de permitidos para la opción seleccionada
          const isDocumentInvalid = !selectedOptionConfig.typedocuments.some(
            (doc) => doc.id == documentTypeId,
          );

          if (isDocumentInvalid) {
            // Si el documento no es válido, agregar su ID a la lista de documentos a eliminar
            idsToRemove.push(document.id);
          }
        });
      }

      // Agregar los IDs de documentos a eliminar al FormData
    }
  }
}



// WEBPACK FOOTER //
// D:/inetpub/wwwroot/kaizen-ng/src/app/modules/disability/components/candidate-disabilities-admin/candidate-disabilities-admin/new-candidate-disabilities-admin/new-candidate-disabilities-admin.component.ts